import { TabMenu } from "primereact/tabmenu";
import { classNames } from "primereact/utils";
import { Link } from "react-router-dom";

import { usePageHeaderContext } from "../../page-header.context";
import styles from "../../page-header.module.scss";
import { PageHeaderTabSelect } from "../tab-select";
import type { PageHeaderTabsViewModel } from "./types-tabs";

/** Abas por rota: `TabMenu` do DS com um `Link` por aba. No mobile mostra o `TabSelect` no lugar. */
export function PageHeaderTabsView({
  isMobile,
  items,
  activeIndex,
  onTabChange,
  ariaLabel,
  mobileQuery,
  className,
  rest,
}: PageHeaderTabsViewModel) {
  const { classNames: parts, partTestId } = usePageHeaderContext();

  if (isMobile) {
    return (
      <PageHeaderTabSelect
        items={items}
        aria-label={ariaLabel}
        mobileQuery={mobileQuery}
        className={className}
        {...rest}
      />
    );
  }

  return (
    <nav
      className={classNames(styles.tabs, parts.tabs, className)}
      aria-label={ariaLabel}
      data-testid={partTestId("abas")}
      {...rest}
    >
      <TabMenu
        className={styles.tabMenu}
        model={items.map((item, index) => ({
          label: item.label,
          disabled: item.disabled,
          template: (_item, options) =>
            item.disabled ? (
              // `<a>` sem `href` (não foca nem navega): o tema do TabMenu desenha a aba na `<a>`, não no `<span>`.
              <a
                className={classNames(options.className, parts.tab)}
                aria-disabled="true"
                title={item.title}
              >
                {item.label}
              </a>
            ) : (
              <Link
                to={item.to}
                title={item.title}
                className={classNames(options.className, parts.tab)}
                aria-current={index === activeIndex ? "page" : undefined}
              >
                {item.label}
              </Link>
            ),
        }))}
        activeIndex={activeIndex}
        onTabChange={onTabChange}
        pt={{ menu: { role: "list" }, menuitem: { role: "listitem" } }}
      />
    </nav>
  );
}
